import { useEffect } from 'react';

export const useEqualHeightByClass = (
    className: string,
    ...triggers: Array<string | number | boolean>
) => {
    useEffect(() => {
        let animationFrameId: number;
        const elements = Array.from(
            document.querySelectorAll(`.${className}`),
        ) as Array<HTMLElement>;
        if (elements.length === 0) return;

        const resize = () => {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(() => {
                elements.forEach((el) => (el.style.height = 'auto'));
                const maxHeight = Math.max(
                    ...elements.map((el) => el.offsetHeight),
                );
                elements.forEach((el) => (el.style.height = `${maxHeight}px`));
            });
        };

        const observer = new ResizeObserver(resize);
        elements.forEach((el) => observer.observe(el));
        resize();

        return () => {
            observer.disconnect();
            cancelAnimationFrame(animationFrameId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [className, ...triggers]);
};
